export class BacForm {
  externalId: string;
  name: string;
  description: string;
  type: 'Entrant' | 'Traitement';
  nePasUtilise: boolean;
  transfertManuel: boolean;
  virtuel: boolean;
  constructor(data?) {
    Object.assign(this, data);
  }
}

export class iBacForm {
  externalId: string;
  name: string;
  description: string;
  type: string;
  typeDisplay: string;
  nePasUtilise: boolean;
  id: number;
  transfertManuel: boolean;
  constructor(data?) {
    Object.assign(this, data);
    this.typeDisplay = this.type === 'Entrant' ? 'Entrée' : this.type;
  }
}
